export default __webpack_public_path__ + "static/media/OpenSans-Light.bb2beef6.woff";